export default {
  state: {
    /**
     * * 当前门店经营状态：0未绑定负责人，1营业中，2已打烊
     */
    storeBusinessStatus: 2,
    /**
     * * 当前区域、分公司状态：0禁用，1启用
     */
    storeStatus: 0,
  },
  mutations: {
    SET_STORE_BUSINESS_STATUS(state, val) {
      state.storeBusinessStatus = val
    },
    SET_STORE_STATUS(state, val) {
      state.storeStatus = val
    },
  },
}
